import React from 'react';
import { Container } from '@themesberg/react-bootstrap';
import { useResponsive } from '../hooks/useResponsive';

const ResponsiveContainer = ({ 
  children, 
  fluid = false, 
  className = '', 
  mobileClass = 'container-mobile',
  ...props 
}) => {
  const { isMobile } = useResponsive();
  
  const containerClass = `${className} ${isMobile ? mobileClass : ''}`.trim();
  
  return (
    <Container 
      fluid={fluid} 
      className={containerClass}
      {...props}
    >
      <div className={isMobile ? 'content-mobile' : ''}>
        {children}
      </div>
    </Container>
  );
};

export default ResponsiveContainer;